import script from "./Layout2ContentsList.vue?vue&type=script&setup=true&lang=js"
export * from "./Layout2ContentsList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__